import React from 'react';

export const useLocationContext = () => {
    const value = React.useContext(LocationContext);

    if (value === undefined) {
        throw new Error(
            'useLocationContext must be used within LocationProvider',
        );
    }

    return value;
};

interface LocationContextShape {
    placeName: string;
    shortPlaceName: string;
    location_slug: string;
}

export const LocationContext = React.createContext<
    Partial<LocationContextShape>
>({});

interface LocationProviderProps {
    shortPlaceName: string;
    location_slug?: string;
    placeName?: string;
}

/**
 * Location Provider that holds static information passed from
 * server to the client that won't update during the
 * course of the current session.
 *
 * @param props
 * @returns
 */
export const LocationProvider: React.FunctionComponent<
    LocationProviderProps
> = (props) => {
    const { placeName, shortPlaceName, location_slug } = props;
    const [value] = React.useState({
        placeName,
        shortPlaceName,
        location_slug,
    });

    return (
        <LocationContext.Provider value={value}>
            {props.children}
        </LocationContext.Provider>
    );
};

export default LocationProvider;
